import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { verifySession } from '../services/adminService';
import { setAdmin } from '../../Redux/adminSlice';

// Admin components
import AdminLogin from '../auth/AdminLogin';
import AdminLayout from '../pages/AdminLayout';
import Dashboard from '../pages/Dashboard';
import UsersManagement from '../pages/UsersManagement';
import CompaniesManagement from '../pages/CompaniesManagement';
import AffiliateManagement from '../pages/AffiliateManagement';
import InstagramAnalytics from '../pages/InstagramAnalytics';
import Settings from '../pages/Settings';
import MarketPlace from '../marketplace/MarketPlace';
import AdvertisingManagement from '../pages/AdvertisingManagement';
// import NotFoundPage from '../components/NotFoundPage';

const AdminRoutes = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.admin);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  useEffect(() => {
    const checkAdminSession = async () => {
      try {
        // Check if userType is admin in localStorage
        const userType = localStorage.getItem('userType');
        if (userType === 'admin') {
          const response = await verifySession();
          if (response.success) {
            dispatch(setAdmin(response.admin));
          } else {
            // Session is invalid, clear localStorage
            localStorage.removeItem('userType');
          }
        }
      } catch (error) {
        // Session verification failed, clear localStorage
        localStorage.removeItem('userType');
      } finally {
        setIsCheckingAuth(false);
      }
    };

    checkAdminSession();
  }, [dispatch]);

  // Add admin-page class to body when admin routes are active
  useEffect(() => {
    document.body.classList.add('admin-page');
    
    // Cleanup: remove the class when component unmounts
    return () => {
      document.body.classList.remove('admin-page');
    };
  }, []);

  // Show loading while checking authentication
  if (isCheckingAuth) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="login" element={<AdminLogin />} />
      
      {/* Protected Admin Routes */}
      <Route
        path="/*"
        element={isAuthenticated ? <AdminLayout /> : <Navigate to="/auth/admin/login" />}
      >
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="users" element={<UsersManagement />} />
        <Route path="companies" element={<CompaniesManagement />} />
        <Route path="affiliate" element={<AffiliateManagement />} />
        <Route path="instagram-analytics" element={<InstagramAnalytics />} />
        <Route path="settings" element={<Settings />} />
        <Route path="marketplace" element={<MarketPlace />} />
        <Route path="advertising" element={<AdvertisingManagement />} />
        {/* Fallback for any undefined admin routes and redirect to dashboard */}
        <Route path="*" element={<Navigate to="dashboard" replace />} />
        {/* <Route path="*" element={<NotFoundPage />} /> */}
      </Route>
    </Routes>
  );
};

export default AdminRoutes; 